import { Component, OnInit } from '@angular/core';
import {PhysicianService} from '../../service/physician.service';

@Component({
  selector: 'app-unpublished-comments',
  templateUrl: './unpublished-comments.component.html',
  styleUrls: ['./unpublished-comments.component.css']
})
export class UnpublishedCommentsComponent implements OnInit {

  constructor(private physicianService: PhysicianService) { }

  commentsList = [];
  totalNumberOfComments:any;
    itemsPerPage = 10;
    currentPage = 1;
    loading=false;

  ngOnInit() {
    this.getUnpublishedComments('');
  }

  getUnpublishedComments(status) {
    this.loading = true;
    this.physicianService.getPhysicianUnpublishedComment(status, this.currentPage -1, this.itemsPerPage).subscribe(
        res => {
      let response = res.json();
      this.commentsList = response.commentsList;
      this.totalNumberOfComments = response.commentsListSize;
      this.loading = false;
    })
  }


  publishReviewComments(id) {
      this.physicianService.publishPhysicianComment(id).subscribe(
          data => {
              this.getUnpublishedComments('');
          },
          error1 => {
            console.log(error1);
          }
      )
  }

  onChangeStatusFilter(value) {
    console.log(value);
    this.getUnpublishedComments(value)
}

    pageChanged(event) {
        this.currentPage = event;
        this.commentsList = [];
        this.getUnpublishedComments('');
        console.log(event);
    }

}
